<template>
    <div class="about-rp">
        <h3 class="indent">Леене</h3>
        <p class="indent">Компанията има леярна, оборудвана с 6 линии за непрекъснато леене и общ производствен капацитет от 96 000 тона на година, които обслужват потребностите на валцовото производство. Основният фокус е върху сплавите от серии 1xxx, 3xxx, 8xxx и 5ххх подходящи за повечето от фолиевите продукти на пазара както и за много видове листа и ленти с разнообразни индустриални приложения.</p>
        <p class="indent">Химичният състав е в съответсвие с международните стандарти като EN 573-3 или фирмени стандарти, разработени специално да осигурят най-доброто качество на крайния продукт.</p>
        <div class="about-rp-table">
          <div class="about-rp-table-row">
            <span>Дебелина на лента:</span>
            <span>5 - 10 мм</span>
          </div>
          <div class="about-rp-table-row">
            <span>Ширина на лента:</span>
            <span>max. 1800 мм</span>
          </div>
          <div class="about-rp-table-row">
            <span>Сплави:</span>
            <span>1xxx, 3xxx, 5xxx, 8ххх серия</span>
          </div>
        </div>
        <img class="about-rp-img" src="/static/img/about/rp/1.jpg" alt="Валцоване">
        <h3 class="indent">Валцоване</h3>
        <p class="indent">Валцовият цех е оборудван със съвременни технологии за студено валцоване, производство и обработка на тънки ленти и фолио. Оборудването за сепариране, обезмасляване, надлъжно и напречно рязане позволява производството на широка гама от продукти за строителството, автомобилната промишленост, производството на топлообменници, опаковъчната индустрия и други сектори.</p>
        <p class="indent">Продуктовата гама включва батерийно, домакинско, контейнерно, конверторно и техническо фолио, финсток, алуминиеви листи и ленти.</p>
      <p class="indent">През 2026 г. Валцов цех 2 беше разширен с нов ACHENBACH OPTIMILL® 4-валцов стан за батерийно фолио, разширявайки възможностите на „Алкомет“ за производство на ултратънко алуминиево фолио.</p>
        <p class="indent">С общ капацитет от 115 000 тона годишно, „Алкомет“ затвърждава позициите си сред водещите производители на алуминиеви валцови продукти в Европа.</p>


      <img class="about-rp-img" src="/static/img/about/rp/2_.jpg" alt="Валцоване">
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-rp {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-rp > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp-table {
  margin: 15px 0;
  width: 60%;
}
.about-rp-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-rp-table-row > span {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-rp-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .about-rp p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-rp-table,
  .about-rp > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-rp-img {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 600px) {
  .about-rp-table-row > span {
    font-size: 12px;
  }
  .about-rp-table-row > span:last-child {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/RollingPlant.vue